<template>
  <div id="users" class="content"
    v-on:click="sectionClicked">
    <div class="contentTop">
      <div class="lthHeaderCnt">
        <div class="lBtn selectAll" v-if="1>2">
          <div class="theSelect"><div class="selectIn"></div></div>
        </div>
        <div class="searchCnt">
          <form v-on:submit.prevent="search">
            <input type="text" class="field" placeholder="Search user..."
              v-on:input="search" v-model="query">
            <button></button>
          </form>
          <div class="pageBtn refresh" v-on:click="getUsers"></div>
        </div>
        <div class="pagination">
          <div class="pageInfo" v-on:click="gotoPage">
            <template v-if="results.length > 0">
              {{((page * limit) + 1).toLocaleString('id')}}-{{((page
              * limit) + results.length).toLocaleString('id')}}
            </template><template v-else>0</template> dari
            {{total.toLocaleString('id')}}</div>
          <div :class="{pageBtn: 1, pagePrev: 1, disabled: page === 0}"
            v-on:click="prevPage"></div>
          <div :class="{pageBtn: 1, pageNext: 1, disabled: ((page
            * limit) + results.length) >= total}"
            v-on:click="nextPage"></div>
          <div class="pageBtn download" v-on:click.stop="download"></div>
          <div class="pageBtn filter" :class="{open: filterOpen}"
            v-on:click.stop="filterOpen = !filterOpen; configOpen = false;
            downloadOpen = false;">
            <div class="ddCnt flex" v-on:click.stop="doNothing" v-if="filterOpen">
              <div class="ddItem ddItemFull">
                <h4>Form</h4>
                <div class="fieldGroup">
                  <div class="fieldCnt">
                    <select class="field" v-model="ft.form">
                      <option value="0">Select Form</option>
                      <option v-for="(item, i) in forms" :key="`frm${i}`"
                        :value="item.formName">{{item.formName || 'Unknown'}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="ddItem ddItemFull">
                <h4>Sign Date</h4>
                <div class="fieldGroup flex">
                  <div class="fieldCnt">
                    <label>From</label>
                    <input type="date" class="field" v-model="ft.from">
                  </div>
                  <div class="fieldCnt">
                    <label>To</label>
                    <input type="date" class="field" v-model="ft.to">
                  </div>
                </div>
                <div class="dateShortcut">
                  <div class="dhItem" v-on:click="ftTime('ft', 'all')">All time</div>
                  <div class="dhItem" v-on:click="ftTime('ft', 'today')">Today</div>
                  <div class="dhItem" v-on:click="ftTime('ft', 'last7')">Last 7 days</div>
                  <div class="dhItem" v-on:click="ftTime('ft', 'thisMonth')">This month</div>
                  <div class="dhItem" v-on:click="ftTime('ft', 'last30')">Last 30 days</div>
                </div>
              </div>
              <div class="ddItem ddItemFull">
                <h4>Email Verified</h4>
                <div class="fieldGroup">
                  <div class="toggle">
                    <div class="radioItem" :class="{on: ft.emailVerification}"
                      v-on:click="ft.emailVerification = !ft.emailVerification">
                      <div class="radioIn">
                        <div class="radioHandle"></div>
                      </div>
                      Show who verify their email only
                    </div>
                  </div>
                </div>
              </div>
              <div class="ddFooter">
                <div class="ddFooterLeft">
                  <button class="btn btnSecondary clearFilter"
                    v-on:click.stop="clearFilter">Clear Filter</button>
                </div>
                <button class="btn btnSecondary"
                  v-on:click.stop="filterOpen = false">Cancel</button>
                <button class="btn btnPrimary"
                  v-on:click.stop="applyFilter">Apply Filter</button>
              </div>
            </div>
          </div>
          <div class="pageBtn config" :class="{open: configOpen}"
            v-on:click.stop="configOpen = !configOpen; filterOpen = false;
            downloadOpen = false;">
            <div class="ddCnt" v-if="configOpen" v-on:click.stop="doNothing">
              <div class="ddItem">
                <h4>Item Per Page</h4>
                <div class="radioCnt">
                  <div class="radioItem" v-on:click="setItemPerPage(25)">
                    <div :class="{radio: 1, checked: limit === 25}"></div>
                    25 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(50)">
                    <div :class="{radio: 1, checked: limit === 50}"></div>
                    50 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(100)">
                    <div :class="{radio: 1, checked: limit === 100}"></div>
                    100 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(150)">
                    <div :class="{radio: 1, checked: limit === 150}"></div>
                    150 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(250)">
                    <div :class="{radio: 1, checked: limit === 250}"></div>
                    250 item per page
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <perfect-scrollbar class="listingCntSc noTab">
      <div class="listingCnt">
        <div class="listingItemCnt">
          <table>
            <tr class="noHover">
              <th class="th1">Submission</th>
              <th>Form</th>
              <th colspan="2">Submit Date</th>
            </tr>
            <tbody v-if="loading">
              <tr class="noHover">
                <td colspan="5" class="tdLoading">
                  <SkAnimation :thumb="false" :tab="false" :header="false" type="user"/>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(item, i) in results" :key="i"
                v-on:click="viewDetail(item)">
                <td class="td1">
                  <h4>{{item.name}}</h4>
                  <p v-if="item.email">{{item.email}}<span class="verified"
                    v-if="item.emailVerified"></span></p>
                </td>
                <td>{{item.formName || 'Unknown'}}</td>
                <td>{{item.timestamp | moment('ddd, DD MMM YYYY HH:mm')}}</td>
                <td class="tdAction">
                  <div class="actionWrapper">
                    <div class="action" v-on:click.stop="itemOpenedId = i"></div>
                    <div :class="{actionOverlay: true, open: itemOpenedId == i}"
                      v-on:click.stop="itemOpenedId = null"></div>
                    <div :class="{actionCnt: true, open: itemOpenedId == i}">
                      <!--
                      <div class="actionItem" v-on:click.stop="editUser()">
                        <img src="../assets/edit-black.png"> Edit User
                      </div>
                      <div class="divider"></div>
                      -->
                      <div class="actionItem actionRed" v-on:click.stop="deleteUser(i, item)">
                        <img src="../assets/delete.png"> Delete
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="tableInfo" v-if="!loading && results.length > 0">
            Displaying {{limit.toLocaleString('id')}}
            of {{total.toLocaleString('id')}}
            items<br />&copy; {{$config.copyright}}. Powered by <a href="https://cmsriver.com"
            target="_blank">CMSRiver</a>
          </div>
        </div>
      </div>
    </perfect-scrollbar>

    <Confirmation ref="confirmDialog"/>
    <Snackbar ref="snackbar"/>
    <FormInputerShort ref="formInputer"/>
    <SubmissionDetail ref="submissionDetail"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';
import SkAnimation from '@/components/SkAnimation.vue';
import FormInputerShort from '@/components/FormInputerShort.vue';
import SubmissionDetail from '@/components/SubmissionDetail.vue';

export default {
  name: 'home',
  components: {
    Confirmation,
    Snackbar,
    SkAnimation,
    FormInputerShort,
    SubmissionDetail,
  },
  data() {
    return {
      limit: 25,
      page: 0,
      total: 0,
      loading: true,
      results: [],
      itemOpenedId: null,
      role: '',
      roles: [],
      searchTimer: null,
      query: '',
      tabActive: 'platinum',
      tabOpen: false,
      configOpen: false,
      filterOpen: false,

      forms: [],
      ft: {
        form: '0',
        from: '',
        to: '',
        emailVerification: false,
      },
    };
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB',
    ]),
    sectionClicked() {
      this.tabOpen = false;
      this.configOpen = false;
      this.filterOpen = false;
    },
    clearFilter() {
      this.$refs.confirmDialog.open({
        title: 'Clear Filter',
        desc: 'Are you sure you want to clear all fiter item?',
        action: 'Clear Filter',
      }, (b) => {
        if (!b) return;
        this.filterOpen = false;
        this.ft.form = '0';
        this.ft.emailVerification = false;
        this.ft.from = '';
        this.ft.to = '';
        this.getUsers();
      });
    },
    applyFilter() {
      this.filterOpen = false;
      this.getUsers();
    },
    viewDetail(item) {
      this.$refs.submissionDetail.open(item);
    },
    ftTime(type, status) {
      if (status === 'all') {
        this[type].from = '';
        this[type].to = '';
      } else if (status === 'today') {
        const d = new Date();
        this[type].from = moment(d).format('YYYY-MM-DD');
        this[type].to = moment(d).format('YYYY-MM-DD');
      } else if (status === 'last7') {
        const d = new Date();
        const d2 = new Date();
        d2.setDate(d2.getDate() - 7);
        this[type].from = moment(d2).format('YYYY-MM-DD');
        this[type].to = moment(d).format('YYYY-MM-DD');
      } else if (status === 'thisMonth') {
        const d = new Date();
        const d2 = new Date();
        d2.setDate(1);
        this[type].from = moment(d2).format('YYYY-MM-DD');
        this[type].to = moment(d).format('YYYY-MM-DD');
      } else if (status === 'last30') {
        const d = new Date();
        const d2 = new Date();
        d2.setDate(d2.getDate() - 30);
        this[type].from = moment(d2).format('YYYY-MM-DD');
        this[type].to = moment(d).format('YYYY-MM-DD');
      }
    },
    download() {
      this.$refs.confirmDialog.open({
        title: 'Generating document',
        desc: `Document for your download is being processed,
          we will notify you when document are ready to download`,
        error: true,
      });
      const dl = (this.ft.emailVerification) ? 'y' : '';
      const frm = (this.ft.form !== '0') ? this.ft.form : '';
      const uri = `user/form/submission/download?sdfrom=${this.ft.from}&sdto=${this.ft.to}`
        + `&verified=${dl}&form=${frm}`;
      this.$http.get(this.$config.uri(uri)).then((r) => {});
    },
    doNothing() {},
    search(e) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getUsers();
      }, 500);
    },
    deleteUser(i, item) {
      this.itemOpenedId = null;
      const name = (item.email) ? item.email : 'User';
      this.$refs.confirmDialog.open({
        title: 'Delete Submission',
        desc: `Are you sure you want to delete ${name}?
          This operation can not be undone.`,
      }, (b) => {
        if (b) this.deleteNow(i, item);
      });
    },
    deleteNow(i, item) {
      this.$refs.formInputer.open({
        title: 'Input Password',
        subtitle: `To prevent from accidentally deleted user,
          you need to input your password.`,
        placeholder: 'Password',
        type: 'password',
        action: 'Delete User',
      }, (b) => {
        if (!b) return;
        this.results.splice(i, 1);
        this.$http.get(this.$config.uri(`user/subscriber/${item.id}/delete`)).then((response) => {
          if (response.data.status !== 200) {
            // Display error
            return;
          }
          this.$refs.snackbar.open({ content: `${item.email} has been deleted.` });
        });
      });
    },
    gotoPage() {
      this.$refs.confirmDialog.open({
        title: 'Go To Page',
        desc: 'Input page number below',
        input: 'Page number...',
        action: 'Go To Page',
      }, (b, c, d) => {
        if (!b) return;
        const page = Number(d);
        if (Number.isNaN(page)) return;
        this.page = page - 1;
        const { slug } = this.$route.params;
        const dirId = this.$route.query.dirId || '';
        window.history.replaceState({}, `page-${this.page}`, `/subscribers?page=${this.page}`);
        this.getData();
      });
    },
    nextPage() {
      if (((this.page * this.limit) + this.results.length) >= this.total) return;
      this.page += 1;
      window.history.replaceState({}, `page-${this.page}`, `/subscribers?page=${this.page}`);
      this.getUsers();
    },
    prevPage() {
      if (this.page === 0) return;
      this.page -= 1;
      window.history.replaceState({}, `page-${this.page}`, `/subscribers?page=${this.page}`);
      this.getUsers();
    },
    setItemPerPage(itemPerPage) {
      this.configOpen = false;
      this.limit = itemPerPage;
      this.getUsers();
    },
    getUsers() {
      this.loading = true;
      const dl = (this.ft.emailVerification) ? 'y' : '';
      const frm = (this.ft.form !== '0') ? this.ft.form : '';
      const uri = `user/form/submission?limit=${this.limit}&page=${this.page}&q=${this.query}`
        + `&sdfrom=${this.ft.from}&sdto=${this.ft.to}&verified=${dl}&form=${frm}`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        this.loading = false;
        this.results = (r.data.status === 200) ? r.data.data : [];
        this.total = (r.data.status === 200) ? r.data.total : 0;
      });
    },
  },
  mounted() {
    this.chTitle('Form Submissions');
    this.chCGB(false);
    this.page = this.$route.query.page ? Number(this.$route.query.page) : 0;
    if (Number.isNaN(this.page)) this.page = 0;
    this.getUsers();

    this.$http.get(this.$config.uri('user/form/names')).then((r) => {
      this.forms = (r.data.status === 200) ? r.data.data : [];
    });
  },
};
</script>


<style scoped lang="scss">
  .info{
    border-bottom: #eee 1px solid;
    margin: 0 -30px;
    .infoContent{
      padding: 20px 30px 30px;
      color: #444;
      max-width: 740px;
      font-size: 17px;
      h4{
        margin: 0 0 4px -3px;
        font-size: 40px;
      }
    }
  }
  .tabCnt{
    .tab{
      flex-grow: 1;
      width: auto;
      &.orange.active{
        &:after{
          background-color: orange;
        }
      }
      &.cyan.active{
        &:after{
          background-color: cyan;
        }
      }
      &.red.active{
        &:after{
          background-color: red;
        }
      }
      &.purple.active{
        &:after{
          background-color: purple;
        }
      }
      &:before{
        background-image: url(../assets/user-black.png);
      }
    }
  }

  .importBtn{
    border: #ccc 1px solid;
    margin-right: 16px;
    border-radius: 50px;
    padding: 5px 16px;
    padding-left: 40px;
    position: relative;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all .3s ease;
    &:hover{
      background-color: #f5f5f5;
      border-color: #bbb;
    }
    &:before{
      width: 20px;
      left: 14px; top: 0; bottom: 0;
      background-image: url(../assets/xls-file-green.png);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      display: block;
      content: "";
    }
  }

  .listingItemCnt{
    margin: 0 -30px;
  }
  .listingHeader{
    padding: 5px 20px;
    padding-left: 18px;
    .exportAll{
      float: right;
      background-color: #0057d8;
      font-size: 15px;
      margin-right: 10px;
      padding: 8px 16px;
      border-radius: 40px;
      transition: all .2s linear;
      color: #fff;
      cursor: pointer;
      img{
        height: 20px;
        margin-bottom: -4px;
        margin-right: 5px;
      }
    }
    .exportAll:hover{
      background-color: #0067ff;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    }
    .lhItem{
      font-size: 15px;
      float: left;
      margin-right: 10px;
      padding: 8px 16px;
      border-radius: 40px;
      opacity: .5;
      transition: all .2s linear;
      cursor: pointer;

      position: relative;
      padding-left: 62px;
      float: none;
      margin-right: 0;
      img{
        height: 20px;
        margin-bottom: -4px;
        margin-right: 5px;
      }
      .checkAll{
        width: 14px; height: 14px;
        border: #777 2px solid;
        border-radius: 4px;
        float: left;
        margin-right: 10px;
      }
    }
    .lhItem.rejectAll{
      opacity: 1;
      color: red;
    }
    .lhItem:before{
      content: "";
      position: absolute;
      left: 12px; top: -1px;
      width: 36px; height: 36px;
      background-color: #ccc;
      border-radius: 50%;
    }
    .lhItem:hover{
      // background-color: #eee;
      opacity: 1;
    }
  }
  table{
    border-collapse: collapse;
    width: 100%;
    tr{
      cursor: pointer;
      &.noHover{
        cursor: default;
      }
      th{
        text-align: left;
        font-weight: bold;
        color: #999;
        padding: 10px 0;
        padding-left: 20px;
        border-bottom: #eee 1px solid;
        text-transform: uppercase;
      }
      th.th1{
        padding-left: 30px;
      }
      td{
        padding: 14px 0;
        padding-left: 20px;
        border-bottom: #eee 1px solid;
        position: relative;
        white-space: nowrap;
        vertical-align: top;
        &.tdLoading{
          padding: 0 30px;
          // border: none;
          &:hover{
            background-color: #fff;
          }
        }
        b{
          font-weight: 600;
        }
        &.tdAction{
          vertical-align: top;
        }
        &.td1{
          padding-left: 30px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          max-width: 200px;
          font-weight: 600;
          h4{
            margin: 0;
            font-size: 16px;
            font-weight: 600;
            display: flex;
            .verified{
              display: block;
              width: 24px; height: 24px;
              margin-left: 4px;
              background-image: url(../assets/verified.png);
              background-size: 100% auto;
              background-position: center;
              background-repeat: no-repeat;
              margin-top: -2px;
              margin-bottom: -20px;
            }
          }
          p{
            margin: 2px 0 0;
            font-weight: normal;
            color: #767676;
            display: flex;
            .verified{
              display: block;
              width: 24px; height: 24px;
              margin-left: 4px;
              background-image: url(../assets/verified.png);
              background-size: 100% auto;
              background-position: center;
              background-repeat: no-repeat;
              margin-top: -2px;
              margin-bottom: -20px;
            }
          }
        }
        .actionWrapper{
          position: relative;
          display: flex;
          padding-right: 10px;
          .ttCnt{
            position: relative;
            .tt{
              position: absolute;
              top: 100%; right: -20px;
              background-color: rgba(0,0,0,.8);
              color: #fff;
              padding: 4px 10px;
              border-radius: 3px;
              display: none;
              font-size: 13px;
            }
            &:hover{
              .tt{
                display: block;
              }
            }
          }
        }
        .deliveryStats{
          display: flex;
          font-size: 13px;
          align-items: center;
          color: #767676;
          .statsItem{
            padding: 5px 10px;
            padding-left: 32px;
            position: relative;
            border-radius: 50px;
            cursor: pointer;
            &:before{
              content: "";
              position: absolute;
              left: 10px; top: 0; bottom: 0;
              width: 16px;
              background-position: center;
              background-repeat: no-repeat;
              background-size: contain;
              opacity: .5;
            }
            &:hover{
              background-color: #d7d7ea;
              color: #444;
              &:before{
                opacity: .6;
              }
            }
            &.waStats{
              &:before{
                background-image: url(../assets/whatsapp-o.png);
              }
            }
            &.smsStats{
              &:before{
                background-image: url(../assets/sms-o.png);
              }
            }
          }
        }
        .action{
          margin-top: -4px;
          position: relative;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background-image: url(../assets/more.png);
          background-size: 18px auto;
          background-repeat: no-repeat;
          background-position: center;
          opacity: .4;
          cursor: pointer;
          &.btn{
            width: auto;
            padding: 0 14px;
            margin-right: 6px;
            background: none;
            font-weight: 500;
            font-size: 15px;
            display: flex;
            align-items: center;
            border-radius: 50px;
            opacity: .8;
            border: #ccc 1px solid;
            &:hover{
              opacity: 1;
            }
            img{
              height: 20px;
              margin-right: 8px;
            }
          }
          &.star{
            background-image: url(../assets/star.png);
            &.stared{
              opacity: 1;
              background-image: url(../assets/star-active.png);
            }
          }
          &.share{
            background-image: url(../assets/share.png);
          }
          &.stats{
            background-image: url(../assets/stats.png);
          }
          &:hover{
            background-color: #d7d7ea;
            opacity: .7;
          }
        }
        .actionCnt{
          position: absolute;
          background: #fff;
          top: 100%;
          // border: 1px solid #ccc;
          box-shadow: 1px 1px 4px rgba(0,0,0,.2);
          border-radius: 10px;
          padding: 10px 0;
          white-space: nowrap;
          text-align: left;
          right: 14px;
          z-index: 4;
          margin-top: -5px;
          display: none;
          .divider{
            border-top: #eee 1px solid;
            padding-top: 4px;
            margin-top: 4px;
          }
          .actionItem{
            display: block;
            cursor: pointer;
            list-style: none;
            padding: 7px 42px;
            color: #444;
            font-size: 14px;
            min-width: 100px;
            img{
              height: 15px;
              margin: -4px 4px -2px -22px;
            }
          }
          .actionItem.actionRed{
            color: red;
          }
          .actionItem:hover{
            background-color: #eee;
          }
        }
        .actionCnt.open{
          display: block;
        }
        .actionOverlay{
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 3;
          display: none;
        }
        .actionOverlay.open{
          display: block;
        }
        // .action{
        //   position: absolute;
        //   right: 14px;
        //   top: 6px;
        //   width: 34px;
        //   height: 34px;
        //   border-radius: 50%;
        //   background-image: url(../assets/more.png);
        //   background-size: 18px auto;
        //   background-repeat: no-repeat;
        //   background-position: center;
        //   opacity: .4;
        //   cursor: pointer;
        // }
        // .action:hover{
        //   background-color: #ddd;
        //   opacity: .7;
        // }
        // .actionCnt{
        //   position: absolute;
        //   background: #fff;
        //   top: 40px;
        //   // border: 1px solid #ccc;
        //   box-shadow: 1px 1px 4px rgba(0,0,0,.2);
        //   border-radius: 10px;
        //   padding: 10px 0;
        //   white-space: nowrap;
        //   text-align: left;
        //   right: 14px;
        //   z-index: 4;
        //   margin-top: -5px;
        //   display: none;
        //   .divider{
        //     border-top: #eee 1px solid;
        //     padding-top: 4px;
        //     margin-top: 4px;
        //   }
        //   .actionItem{
        //     cursor: pointer;
        //     list-style: none;
        //     padding: 7px 42px;
        //     color: #444;
        //     font-size: 14px;
        //     min-width: 100px;
        //     img{
        //       height: 15px;
        //       margin: -4px 4px -2px -22px;
        //     }
        //   }
        //   .actionItem.actionRed{
        //     color: red;
        //   }
        //   .actionItem:hover{
        //     background-color: #eee;
        //   }
        // }
        // .actionCnt.open{
        //   display: block;
        // }
        // .actionOverlay{
        //   position: fixed;
        //   top: 0;
        //   left: 0;
        //   right: 0;
        //   bottom: 0;
        //   z-index: 3;
        //   display: none;
        // }
        // .actionOverlay.open{
        //   display: block;
        // }
      }
      td.tdHeader{
        padding: 0;
      }
    }
    tbody{
      tr:hover{
        background-color: #f5f5f5;
        background-color: #f0f4ff;
        // cursor: pointer;
      }
    }
  }
</style>
